import React from "react";
import classnames from "classnames";
import styles from "./svg-icon.css";

type SVGIconName =
    | "account-icon"
    | "basket-icon"
    | "bell"
    | "bell-empty"
    | "cart"
    | "chevron"
    | "chevron-thin"
    | "clear"
    | "cross"
    | "cross-thin"
    | "discount"
    | "external-link"
    | "fat-arrow"
    | "filters"
    | "heart"
    | "heart-broken"
    | "preview-icon"
    | "hyperlink"
    | "minus"
    | "plus"
    | "plus-thin"
    | "round-minus"
    | "round-plus"
    | "plus-bag"
    | "price-drop"
    | "search"
    | "round-search"
    | "sort"
    | "tag"
    | "tick"
    | "tick-new"
    | "truck"
    | "lysts-search"
    | "lysts-control"
    | "lysts-recommendations"
    | "value-proposition-search"
    | "value-proposition-shopping-bag"
    | "value-proposition-star"
    | "saved-search"
    | "search-button"
    | "saved-search-empty"
    | "saved-search-bookmark"
    | "stopwatch"
    | "tap-hand"
    | "mail-plane"
    | "magnify"
    | "heart-empty"
    | "round-chevron"
    | "alert-new"
    | "heart-unpressed"
    | "heart-pressed"
    | "basket-new"
    | "user"
    | "expand"
    | "round-radiobutton"
    | "round-radiobutton-checked"
    | "round-checkbox"
    | "round-checkbox-checked"
    | "icon-bulb"
    | "round-select-marker"
    | "square-chevron"
    | "arrow-icon"
    | "search-icon"
    | "shoppingbag-icon"
    | "searches-icon"
    | "searches-icon-filled"
    | "searches-icon-empty"
    | "alerts-icon"
    | "user-icon"
    | "twitter"
    | "facebook"
    | "instagram"
    | "pinterest"
    | "info-icon"
    | "heart-icon-empty"
    | "heart-icon-filled"
    | "arrow-right"
    | "qr-icon"
    | "stars"
    | "icon-smiley";

interface SVGIconProps {
    name: SVGIconName;
    className?: string;
}

interface SVGIconRotateProps extends SVGIconProps {
    rotate?: number;
}

interface SVGIconFlipProps extends SVGIconProps {
    flip?: boolean;
}

function SVGIcon({
    name,
    className,
    ...props
}: SVGIconRotateProps | SVGIconFlipProps): React.ReactElement {
    const useTag = `<use xlink:href="#${name}" />`;

    let inlineStyles = {};
    if ("rotate" in props) {
        inlineStyles["transform"] = `rotate(${props.rotate}deg)`;
    } else if ("flip" in props) {
        inlineStyles["transform"] = "rotateY(180deg)";
    }

    return (
        <svg
            style={inlineStyles}
            aria-hidden="true"
            className={classnames(styles.svgIcon, `svg-icon-${name}`, className)}
            dangerouslySetInnerHTML={{ __html: useTag }}
        />
    );
}

export default SVGIcon;
